import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { showNotification } from 'src/app/helpers/show-toast';
import { FAQ } from 'src/app/_models/FAQ.model';
import { FAQService } from 'src/app/_services/faq.service';

@Component({
  selector: 'app-add-faq',
  templateUrl: './add-faq.component.html',
  styleUrls: ['./add-faq.component.scss'],
})
export class AddFaqComponent implements OnInit {
  pageTitle: string = 'FAQs';
  ranks = Array(15);

  featuredSpecialityImage;
  editMode = false;

  faq: FAQ = {};

  constructor(
    private faqService: FAQService,
    private activatedRoute: ActivatedRoute,
    public toastr: ToastrService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.editMode =
      this.activatedRoute.snapshot.url[1] &&
      this.activatedRoute.snapshot.url[1].path === 'edit' &&
      true;

    if (this.editMode) {
      const id = this.activatedRoute.snapshot.params.faqId;
      this.faqService.getFAQById(id).subscribe((res) => {
        this.faq = res.data;

      });
    }
  }

  onAddFAQ(): void {


    if (this.editMode) {
      this.faqService.updateFAQ(this.faq).subscribe((res) => {
        showNotification(
          'success',
          `FAQ has been updated`,
          this.toastr
        );
        this.router.navigateByUrl('FAQs');
      });
    } else {
      this.faqService.addNewFAQ(this.faq).subscribe((res) => {
        showNotification(
          'success',
          `FAQ has been added`,
          this.toastr
        );
        this.router.navigateByUrl('FAQs');
      });
    }
  }
}
